module.exports = __webpack_public_path__ + "img/curly-bracket.7f421091.svg";